import { SVGProps } from 'react';

const CodeXml = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m18 16 4-4-4-4M6 8l-4 4 4 4m8.5-12-5 16"
    />
  </svg>
);
export default CodeXml;
